import { KYMW1302Model } from '../kymw1302.model';
import { KYMW1302PublishBillDataModel } from '../vo/kymw1302-publish-bill-data.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 掲載料請求データ出力画面　掲載料請求データを出力するサービス
 *
 * @export GetPublishBillDataCSVService
 * @class GetPublishBillDataCSVService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPublishBillDataCSVService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1302Model}
   * @memberof GetPublishBillDataCSVService
   */
  private model: KYMW1302Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {KYMW1302PublishBillDataModel}
   * @memberof GetPublishBillDataCSVService
   */
  private vo: KYMW1302PublishBillDataModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetPublishBillDataCSVService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPublishBillDataCSVService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCodeFrom: this.vo.orderCodeFrom,
        OrderCodeTo: this.vo.orderCodeTo,
        MediumType: this.vo.mediumType,
        CoopCode: this.vo.coopCode,
        PageNumFrom: this.vo.pageFrom,
        PageNumTo: this.vo.pageTo,
        OrderNum: this.vo.orderNum,
        WPublishFlag: this.vo.withoutWPublishFlag
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPublishBillDataCSVService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1302Model>model;
    this.vo = <KYMW1302PublishBillDataModel>vo;
    this.successFunc = successFunc;
    this.send('getPublishBillDataCSV', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPublishBillDataCSVService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
